
// ─────────────────────────────────────────────────────────────────────────────
// File: components/weather/DateSwitcher.jsx
// ─────────────────────────────────────────────────────────────────────────────
import React from 'react';

export default function DateSwitcher({ dates, value, onChange }) {
  if (!dates?.length) return null;
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', margin: '8px 0 16px' }}>
      {dates.map((d) => (
        <button
          key={d}
          onClick={() => onChange(d)}
          style={{
            padding: '6px 10px',
            borderRadius: 999,
            border: '1px solid #cbd5e1',
            background: d === value ? '#111827' : '#ffffff',
            color: d === value ? '#ffffff' : '#111827',
            fontSize: 13,
            cursor: 'pointer',
          }}
        >
          {d}
        </button>
      ))}
    </div>
  );
}